import { LitEntity, html } from '../../utility/lit-entity';
import { sharedStyles } from '../../styles/shared-styles';
import './location-assign-modal';

class LocationAssignButton extends LitEntity {
  static get properties() {
    return {
      showModal: { type: Boolean },
    };
  }

  static get styles() {
    return sharedStyles;
  }

  render() {
    return html`
      <button class="button button--contained" @click="${this._onClick}">Assign</button>
      <location-assign-modal
        .href="${this.href}"
        ?hide="${!this.showModal}"
        @close="${() => this.showModal = false}"
        @response="${({ detail }) => this.dispatchEvent(new CustomEvent('response', { detail, bubbles: true, composed: true }))}"
      ></location-assign-modal>
    `;
  }

  _onClick(e) {
    e.stopPropagation();
    this.showModal = true;
  }
}

window.customElements.define('location-assign-button', LocationAssignButton);
